import { IGetAllCategoriesRequest } from '../../types/api/request/categoriesrequest';
import { IGetAllCategoriesResponse } from '../../types/api/response/categoriesResponse';
import { ICategory, ISubcategory } from '../../types/store';
import axiosClient from '../axiosClient';
import { CategoriesEndpoint } from '../endpoints/categories';

export const CategoriesService = {
  async getAllCategories(payload?: IGetAllCategoriesRequest): Promise<IGetAllCategoriesResponse> {
    const params = payload ? `?page=${payload?.page}&size=${payload?.size}` : ``;

    const res = await axiosClient.get<IGetAllCategoriesResponse>(
      `${CategoriesEndpoint.GET_ALL_CATEGORIES}${params}`,
    );
    return res.data;
  },

  async syncCategories(): Promise<ICategory[]> {
    const res = await axiosClient.post<ICategory[]>(CategoriesEndpoint.SYNC_CATEGORIES);
    return res.data;
  },

  async syncSubcategories(): Promise<ISubcategory[]> {
    const res = await axiosClient.post<ISubcategory[]>(CategoriesEndpoint.SYNC_SUBCATEGORIES);
    return res.data;
  },

  async updateSubcatImage(category: string, subcategory: string, image: File) {
    const formData = new FormData();
    formData.append('image', image);

    const url = CategoriesEndpoint.UPDATE_SUBCAT_IMAGE.replace(':category', category).replace(
      ':subcategory',
      subcategory,
    );
    const res = await axiosClient.put(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return res.data;
  },

  async toggleShowinApp(category: string): Promise<ICategory> {
    const url = CategoriesEndpoint.TOGGLE_SHOW_IN_APP.replace(':category', category);
    const res = await axiosClient.patch<ICategory>(url);

    return res.data;
  },
};
